import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Components as Switch } from './switch.style';
import SwitchStandard from './SwitchStandard';
import Label from '../Label';
import ErrorMessage from '../ErrorMessage';
import Hint from '../Hint';
export const SwitchGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'group-switch',
      options = [],
      orientation = 'horizontal',
      error,
      hint,
      label,
      onChange,
      value,
      name,
      disabled = false,
      fit = 'medium',
      type,
      width
    } = props,
    rest = __rest(props, ["className", "options", "orientation", "error", "hint", "label", "onChange", "value", "name", "disabled", "fit", "type", "width"]);
  const handleOnChange = (e, index) => {
    // Update the checked value with index
    const updatedOptions = options.map((option, indexOption) => {
      if (index === indexOption) {
        return _extends(_extends({}, option), {
          checked: e.target.checked
        });
      } else {
        return _extends(_extends({}, option), {
          checked: Array.isArray(value) ? value.indexOf(option.value) > -1 ? true : false : option.checked
        });
      }
    });
    if (onChange) {
      onChange(e, updatedOptions, type);
    }
  };
  return _jsxs(Switch.FieldSet, _extends({
    fit: fit,
    width: width,
    className: className
  }, {
    children: [label && _jsx(Label, _extends({
      label: label,
      fit: fit,
      className: className
    }, rest)), error && _jsx(ErrorMessage, _extends({
      fit: fit
    }, rest)), hint && _jsx(Hint, {
      hint: hint,
      fit: fit
    }), _jsx(Switch.Container, _extends({
      orientation: orientation,
      fit: fit
    }, {
      children: options.map((option, index) => _jsx(Switch.Group, _extends({
        orientation: orientation,
        fit: fit
      }, {
        children: _jsx(SwitchStandard, _extends({
          name: name,
          fit: fit,
          ref: ref
        }, option, {
          disabled: disabled !== false ? disabled : !!option.disabled,
          checked: Array.isArray(value) ? value.indexOf(option.value) > -1 ? true : false : option.checked,
          onChange: e => handleOnChange(e, index)
        }), index)
      }), index))
    }))]
  }));
});
export default SwitchGroup;